import { put } from "redux-saga/effects";
import { maintenanceAction } from "../action";
import { Client } from "../../../utils/transport";
import { SOMETHING_WENT_WRONG } from "constants/staticText";
import { notification } from "antd";

export function* reprocessDataSaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/maintenance/reprocess_app_stats/?months=${action.payload.days}`,
    headers: {
      ...action.payload.headers,
    },
  };
  try {
    const response = yield Client.request(config);

    yield put(maintenanceAction.reprocessDataSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(maintenanceAction.reprocessDataFailed(errorMessage));
  }
}

export function* triggerMaintenanceSaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/maintenance/maintenance/`,
    headers: {
      ...action.payload.headers,
    },
  };
  try {
    const response = yield Client.request(config);

    yield put(maintenanceAction.triggerMaintenanceSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(maintenanceAction.triggerMaintenanceFailed(errorMessage));
  }
}

export function* deleteUserScreenshotsSaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/maintenance/delete_screenshots_for_date_range/${action.payload.identityId}?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}`,
    headers: {
      ...action.payload.headers,
    },
  };
  try {
    const response = yield Client.request(config);

    yield put(maintenanceAction.deleteUserScreenshotsSuccess(response.data));
    notification.success({
      message: "Success",
      description: "User screenshots deleted successfully.",
      duration: 3,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(maintenanceAction.deleteUserScreenshotsFailed(errorMessage));
  }
}

export function* sendEmailReportSaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/maintenance/reports/${action.payload.dateRange}/${action.payload.reportType}`,
    headers: {
      ...action.payload.headers,
      "Content-Type": "application/json",
    },
    data: {
      items: action.payload.recipients,
    },
  };

  try {
    const response = yield Client.request(config);

    yield put(maintenanceAction.sendEmailReportSuccess(response.data));
    notification.success({
      message: "Email Sent Successfully",
      description: `Report has been sent to ${action.payload.recipients.length} recipient(s).`,
      duration: 3,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(maintenanceAction.sendEmailReportFailed(errorMessage));
  }
}
